const updateOrgName = 'UPDATE_ORG_NAME'
const updateActiveMenu = 'UPDATE_ACTIVE_MENU'
const createNewWorkSpace = 'CREATE_NEW_WORKSPACE'

export default {
    updateOrgName,
    updateActiveMenu,
    createNewWorkSpace
}